<template>
  <div class="ui-chart">
    <!-- eslint-disable-next-line vue/component-name-in-template-casing -->
    <highcharts :options="chartOptions" />
  </div>
</template>

<script>

export default {
  name: 'UiChart',

  props: {
    chartOptions: {
      type: Object,
      required: true,
    },
  },

};
</script>

